__turbopack_context__.v({
  "sticky-tabs-container": "GYn6bq_sticky-tabs-container",
  "sticky-tabs-outer-container": "GYn6bq_sticky-tabs-outer-container",
  "tabs": "GYn6bq_tabs",
});
